module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-4-8528bb8df342c63c50562da50dcb49d2.jpg";